import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { Hotel, MiddlewareBaseResponse } from '@ireckonu/shared-ui';

import { ServiceUrlKey } from '../models';
import { ConfigurationQueryService } from './configuration-query.service';

@Injectable({
  providedIn: 'root',
})
export class HotelsService {
  private readonly http = inject(HttpClient);
  private readonly configService = inject(ConfigurationQueryService);

  private get coreApiBaseUrl(): string {
    return this.configService.getServiceUrl(ServiceUrlKey.CoreApiBaseUrl) ?? '';
  }

  private hotels$?: Observable<MiddlewareBaseResponse<Hotel[]>>;

  get(): Observable<MiddlewareBaseResponse<Hotel[]>> {
    if (!this.hotels$) {
      this.hotels$ = this.http
        .get<
          MiddlewareBaseResponse<Hotel[]>
        >(`${this.coreApiBaseUrl}/property/list`)
        .pipe(shareReplay(1));
    }
    return this.hotels$;
  }
}
